<template>
  <div class="home">
    <!-- 新闻分类标签 -->
    <div class="news-tabs">
      <el-tabs v-model="activeTab" @tab-change="handleTabChange">
        <el-tab-pane 
          v-for="category in activeCategories" 
          :key="category.id"
          :label="getCategoryLabel(category)" 
          :name="category.name" 
        />
      </el-tabs>
    </div>

    <div class="news-list">
      <el-card v-for="item in newsList" :key="item.id" class="news-card" @click="goToDetail(item.id)">
        <div class="news-card-content">
          <img v-if="item.cover_image_url" :src="item.cover_image_url" class="news-image" />
          <div class="news-info">
            <div class="news-title-row">
              <h3>{{ item.title }}</h3>
              <el-tag v-if="item.is_pinned" type="warning" size="small" effect="dark">置顶</el-tag>
            </div>
            <p class="news-meta">
              <span>{{ item.category?.name || '未分类' }}</span>
              <span>{{ formatDate(item.created_at) }}</span>
              <span>浏览 {{ item.view_count }}</span>
            </p>
            <p class="news-excerpt">{{ getExcerpt(item.content) }}</p>
          </div>
        </div>
      </el-card>

      <el-pagination
        v-model:current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'HomePage',
  data() {
    return {
      activeTab: null,
      newsList: [],
      categories: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      categoryMap: {
        maxkb: 'MaxKB快讯',
        ai: 'AI速览',
        maxkb_news: 'MaxKB新闻'
      }
    }
  },
  computed: {
    activeCategories() {
      // 只返回启用的分类
      return this.categories.filter(cat => cat.is_active !== false)
    }
  },
  mounted() {
    this.loadCategories()
  },
  methods: {
    async loadCategories() {
      try {
        const response = await api.get('/news/categories/')
        const categoriesList = Array.isArray(response.data) 
          ? response.data 
          : (response.data.results || [])
        this.categories = categoriesList
        
        // 如果有启用的分类，设置默认选中第一个
        if (this.activeCategories.length > 0 && !this.activeTab) {
          this.activeTab = this.activeCategories[0].name
          this.loadNews()
        }
      } catch (error) {
        console.error('加载分类失败:', error)
      }
    },
    async loadNews() {
      if (!this.activeTab) return
      
      try {
        const response = await api.get('/news/items/', {
          params: {
            category: this.activeTab,
            page: this.currentPage,
            page_size: this.pageSize
          }
        })
        this.newsList = response.data.results || []
        this.total = response.data.count || 0
      } catch (error) {
        console.error('加载新闻失败:', error)
        this.newsList = []
        this.total = 0
      }
    },
    getCategoryLabel(category) {
      // 优先使用 display_name，如果没有则使用 categoryMap，最后使用 name
      if (category.display_name) {
        return category.display_name
      }
      return this.categoryMap[category.name] || category.name
    },
    handleTabChange() {
      // 如果当前选中的分类被禁用，切换到第一个启用的分类
      if (this.activeTab && !this.activeCategories.find(cat => cat.name === this.activeTab)) {
        if (this.activeCategories.length > 0) {
          this.activeTab = this.activeCategories[0].name
        } else {
          this.activeTab = null
        }
      }
      this.currentPage = 1
      this.loadNews()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadNews()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadNews()
    },
    goToDetail(id) {
      this.$router.push(`/news/${id}`)
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('zh-CN')
    },
    getExcerpt(content) {
      if (!content) return ''
      const text = content.replace(/<[^>]*>/g, '').substring(0, 100)
      return text.length < content.length ? text + '...' : text
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
}

.news-tabs {
  margin-bottom: 30px;
}

.news-list {
  margin-top: 20px;
}

.news-card {
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s;
}

.news-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.news-card-content {
  display: flex;
  gap: 20px;
}

.news-image {
  width: 200px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
}

.news-info {
  flex: 1;
}

.news-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.news-info h3 {
  margin: 0;
  color: #e0e0e0;
  flex: 1;
}

.news-meta {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  margin-bottom: 10px;
}

.news-meta span {
  margin-right: 15px;
}

.news-excerpt {
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>

